// Reactstrap 9.x leaves `Fade.defaultProps` undefined; that makes the required
// `timeout` prop trip prop-type warnings when parents spread `Fade.defaultProps`.
// Rather than attaching defaultProps (which React warns on for function
// components), relax the propType to optional while keeping the library's
// internal fallback intact.
import { Fade as ReactstrapFade } from 'reactstrap';
import PropTypes from 'prop-types';

const fadeComponent = ReactstrapFade;
if (fadeComponent && fadeComponent.propTypes) {
  const timeoutPropType = PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({
      enter: PropTypes.number,
      exit: PropTypes.number,
      appear: PropTypes.number,
    }),
  ]);

  fadeComponent.propTypes = {
    ...fadeComponent.propTypes,
    timeout: timeoutPropType,
  };
}
